import { render, staticRenderFns } from "./addressItem.vue?vue&type=template&id=ae1f4808&scoped=true"
import script from "./addressItem.vue?vue&type=script&lang=js"
export * from "./addressItem.vue?vue&type=script&lang=js"
import style0 from "./addressItem.vue?vue&type=style&index=0&id=ae1f4808&prod&lang=scss&scoped=true"
import style1 from "./addressItem.vue?vue&type=style&index=1&id=ae1f4808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1f4808",
  null
  
)

export default component.exports